import { ColumnConfig } from "components/Table/types";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import { SearchQueryOrderDirection } from "types/generated";

export const IDP_GROUP_USERS_COLUMNS_STORAGE_KEY = "idpGroupUsersColumnsConfig";
export const FILTERS_ORDER_SETTINGS_KEY = "idpGroupUsersFiltersOrder";

export const initialSortOption = "name";
export const initialSortDirection = SearchQueryOrderDirection.Desc;

export enum IDP_GROUP_USERS_COLUMN_ID {
  NAME = "NAME",
  METHOD = "METHOD",
  STATUS = "STATUS",
  LAST_LOGIN = "LAST_LOGIN",
}

export const ROW_HEADER_ID = IDP_GROUP_USERS_COLUMN_ID.NAME;

const MAX_CELL_WIDTH = 600;

export const IDP_GROUP_USERS_COLUMN_CONFIG: ColumnConfig = {
  [IDP_GROUP_USERS_COLUMN_ID.NAME]: {
    title: "Name",
    minWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
  },

  [IDP_GROUP_USERS_COLUMN_ID.METHOD]: {
    title: "Method",
    minWidth: 50,
    maxWidth: MAX_CELL_WIDTH,
  },

  [IDP_GROUP_USERS_COLUMN_ID.STATUS]: {
    title: "Status",
    minWidth: 130,
    maxWidth: MAX_CELL_WIDTH,
    static: true,
  },
  [IDP_GROUP_USERS_COLUMN_ID.LAST_LOGIN]: {
    title: "Last login",
    minWidth: 130,
    maxWidth: MAX_CELL_WIDTH,
    static: true,
    allowsSorting: true,
  },
};

export const SORT_CONFIG: Record<string, string> = {
  [IDP_GROUP_USERS_COLUMN_ID.NAME]: "name",
  [IDP_GROUP_USERS_COLUMN_ID.LAST_LOGIN]: "lastLogin",
};

export const INITIAL_COLUMNS_VIEW_CONFIG = {
  visible: Object.keys(IDP_GROUP_USERS_COLUMN_CONFIG) as IDP_GROUP_USERS_COLUMN_ID[],
  hidden: [],
};

export const ANALYTICS = {
  analyticsPage: AnalyticsPageOrganization.OrganizationIdpGroupUsers,
};
